import CardSelfCom from "./card_self_com";
import CardCalculateCom from "./card_calculate_com";

const {ccclass,property} = cc._decorator;

@ccclass
export default class CardSelfMgrCom extends cc.Component{

    @property(CardCalculateCom)
    readonly calculateCom : CardCalculateCom = null;

    @property([cc.Button])
    readonly pokerBtns : cc.Button[] = [];

    @property(cc.Node)
    readonly errorNode : cc.Node = null;

    private comList : CardSelfCom[];

    private moveUpCnt : number = 0;

    private comboType : string;

    private result : number;

    private calculateList: number[] = [];

    private clickOpen : boolean = false;

    start(){
                
        //this.comList =  this.node.getComponentsInChildren(CardSelfCom);                
    }

    onEnable(){


        this.comList =  this.node.getComponentsInChildren(CardSelfCom);    

        // this.pokerBtns.forEach(element => {
            
        //     element.node.active = true;
        // });
        //this.showPokerBtn.node.active = true;
        //this.reset();
    }

    onDisable(){
       
        this.reset();
    
    }

    public reset(){

        this.moveUpCnt = 0;
        this.calculateList  = [];
        this.comboType = "";
        this.result = 0;
    }

    public getClickResult() : number{

        return this.result;
    }

    //判断点击的牌有没有牛
    public checkCow() : boolean{
        
        if (this.calculateList.length == 3) {

            return this.result % 10 == 0 
            || this.comboType == "samll" 
            || this.comboType == "boom" 
            || this.comboType == "straight";
        }
        else{
            return false;
        }
    
    }

    public recvCombo( combo : string){

        //this.calculateList = [];
        this.comboType = combo;
    }

    public recvClickOpen(clickOpen : boolean){

        this.clickOpen = clickOpen;
    }

    public onClick(event, customEventData ){

        if (!this.clickOpen) {
            return;
        }
    
        console.log("  card_self_mgr_com onClick " , customEventData);

        let com = this.comList[Number(customEventData)]; 
                    
        if (!com.upState) {
         
            if (this.moveUpCnt < 3) {
                
                com.moveUp();
                this.moveUpCnt++;
            }
        }        
        else{

            com.moveDown()
            this.moveUpCnt --;
        }


        this.calculateList = [];
        this.result = 0;
        /**
         * 牌的结果
         */        

        for (let index = 0; index < this.comList.length; index++) {
            const com = this.comList[index];
         
            if (com.upState) {
                
                this.calculateList.push(com.getPokerNumber());
            }
        }
        
        this.calculateList.forEach(element => {
          
            this.result += element;            
        });

        // if (calculateList.length == 3 ) {
                        
        //     if (this.comboType == "samll" || this.comboType == "boom" || this.comboType == "cow0" ) {                
                
        //         this.errorNode.active = false;                 
                
        //         // this.pokerBtns.forEach(element => {
            
        //         //     element.node.active = false;
        //         // });

        //         let module = ModuleManager.instance.getModuleFromType<BankerBullBullTableModule>(BankerBullBullTableModule);
        //         module.requset_computePoker();
        //     }
        //     else             
        //     {   //有牛
        //         if(result % 10 == 0)
        //         {   
        //             this.errorNode.active = false;                 

        //             // this.pokerBtns.forEach(element => {
            
        //             //     element.node.active = false;
        //             // });

        //             let module = ModuleManager.instance.getModuleFromType<BankerBullBullTableModule>(BankerBullBullTableModule);
        //             module.requset_computePoker();                    

        //         }else{

        //             //拼牌错误
        //             this.errorNode.active = true;

        //             AudioManager.instance.playSound("package/bullbull/audio/start_game");                    
                    
        //         }
        //     }
        // }

        this.calculateCom.updateCalculate(this.calculateList);
    }



  

}